/* How-To Video — interactive player (native video controls).
   States: welcome -> tips(0..n) -> video -> cta */
(function () {
  if (customElements.get('how-to-video')) return;
  try { if (window.console && console.info) console.info('[how-to-video] script v7 loaded'); } catch (e) {}

  function parseTime(v) {
    if (v == null) return 0;
    v = String(v).trim();
    if (v === '') return 0;
    if (v.indexOf(':') === -1) { var n = parseFloat(v); return isFinite(n) ? n : 0; }
    var parts = v.split(':').map(function (p) { return parseInt(p, 10) || 0; });
    var s = 0; for (var i = 0; i < parts.length; i++) s = s * 60 + parts[i];
    return s;
  }
  function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

  class HowToVideo extends HTMLElement {
    connectedCallback() {
      if (this._init) return; this._init = true;

      this.player = this.querySelector('.htv__player');
      this.video = this.querySelector('.htv__video');
      this.welcomeScreen = this.querySelector('[data-htv-screen="welcome"]');
      this.tipsScreen = this.querySelector('[data-htv-screen="tips"]');
      this.ctaScreen = this.querySelector('[data-htv-screen="cta"]');
      this.tipSlides = Array.prototype.slice.call(this.querySelectorAll('[data-htv-tip]'));
      this.tipStep = this.querySelector('[data-htv-tip-step]');
      this.ctaSecondary = this.querySelector('[data-htv-cta-secondary]');

      this.selectedTime = 0;
      this.tipIndex = 0;
      this.tipCount = this.tipSlides.length;
      this.duration = 0;

      this.ctaEnabled = this.dataset.ctaEnabled === '1';
      this.ctaFreq = this.dataset.ctaFrequency || 'every_chapter';
      this.keepLabel = this.dataset.keepLabel || 'Keep watching';
      this.replayLabel = this.dataset.replayLabel || 'Replay from start';
      this.debug = this.dataset.debug === '1';
      this.boundaries = [];
      this.lastTime = 0;
      this.ctaEnd = false;

      try { var raw = this.querySelector('[data-htv-chapters]'); this.chapters = raw ? JSON.parse(raw.textContent) : []; }
      catch (e) { this.chapters = []; }
      this.chapters.forEach(function (c) { c.seconds = parseTime(c.time); });

      this.bindEvents();
      this.setState('welcome');
      this.attachDebug();
    }

    computeBoundaries() {
      if (!isFinite(this.duration) || this.duration <= 0) return;
      var self = this, times = {};
      this.chapters.forEach(function (c) { if (c.seconds > 0 && c.seconds < self.duration) times[Math.round(c.seconds)] = true; });
      this.boundaries = Object.keys(times).map(Number).sort(function (a, b) { return a - b; });
    }

    bindEvents() {
      var self = this;

      this.querySelectorAll('[data-htv-method]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.selectedTime = parseTime(btn.dataset.time);
          self._log('method click', 'time=' + self.selectedTime);
          if (self.tipCount > 0) self.setState('tips', 0);
          else self.toVideo(self.selectedTime, true);
        });
      });

      var playAll = this.querySelector('[data-htv-playall]');
      if (playAll) playAll.addEventListener('click', function () {
        self.selectedTime = 0;
        self._log('play from beginning');
        if (self.tipCount > 0) self.setState('tips', 0);
        else self.toVideo(0, true);
      });

      var nextBtn = this.querySelector('[data-htv-tips-next]');
      var backBtn = this.querySelector('[data-htv-tips-back]');
      if (nextBtn) nextBtn.addEventListener('click', function () {
        if (self.tipIndex < self.tipCount - 1) self.setState('tips', self.tipIndex + 1);
        else self.toVideo(self.selectedTime, true);
      });
      if (backBtn) backBtn.addEventListener('click', function () {
        if (self.tipIndex > 0) self.setState('tips', self.tipIndex - 1);
        else self.setState('welcome');
      });

      if (this.video) {
        var refresh = function () {
          var d = self.video.duration || 0;
          if (isFinite(d) && d > 0 && d !== self.duration) { self.duration = d; self.computeBoundaries(); }
        };
        ['loadedmetadata', 'durationchange', 'loadeddata', 'canplay'].forEach(function (ev) { self.video.addEventListener(ev, refresh); });
        this.video.addEventListener('timeupdate', function () { refresh(); self.checkBoundary(); });
        this.video.addEventListener('seeked', function () { self.lastTime = self.video.currentTime; });
        this.video.addEventListener('ended', function () { self.onEnded(); });
      }

      var restart = this.querySelector('[data-htv-restart]');
      if (restart) restart.addEventListener('click', function () {
        self._log('start video over');
        self.ctaEnd = false;
        self.lastTime = 0;
        self.setState('welcome');
      });

      if (this.ctaSecondary) this.ctaSecondary.addEventListener('click', function () {
        if (self.ctaEnd) self.toVideo(0, true);
        else { self.setState('video'); self.play(); }
      });

      this.bindActions();
    }

    /* ----- CTA boundaries ----- */
    checkBoundary() {
      if (!this.video) return;
      if (!this.ctaEnabled || this.ctaFreq !== 'every_chapter') { this.lastTime = this.video.currentTime; return; }
      if (this.player.dataset.state !== 'video' || this.video.paused) return;
      var cur = this.video.currentTime, hit = false;
      for (var i = 0; i < this.boundaries.length; i++) {
        var b = this.boundaries[i];
        if (this.lastTime < b && cur >= b) { hit = true; break; }
      }
      this.lastTime = cur;
      if (hit) { this._log('CTA boundary fired', 'ct=' + cur.toFixed(2)); this.ctaEnd = false; this.video.pause(); this.setState('cta'); }
    }
    onEnded() { if (this.ctaEnabled) { this.ctaEnd = true; this.setState('cta'); } }

    bindActions() {
      var self = this;
      var printBtn = this.querySelector('[data-htv-print]');
      if (printBtn) printBtn.addEventListener('click', function () { var u = self.dataset.pdfUrl; if (u) window.open(u, '_blank', 'noopener'); });

      var emailOpen = this.querySelector('[data-htv-email-open]');
      var emailForm = this.querySelector('[data-htv-email-form]');
      if (emailOpen && emailForm) emailOpen.addEventListener('click', function () {
        var open = emailForm.hasAttribute('hidden');
        if (open) { emailForm.removeAttribute('hidden'); var inp = emailForm.querySelector('.htv__email-input'); if (inp) inp.focus(); }
        else emailForm.setAttribute('hidden', '');
        emailOpen.setAttribute('aria-expanded', String(open));
      });
      var sendBtn = this.querySelector('[data-htv-email-send]');
      if (sendBtn) sendBtn.addEventListener('click', function () { self.submitEmail(); });
    }

    submitEmail() {
      var self = this;
      var form = this.querySelector('[data-htv-email-form]');
      var input = form.querySelector('.htv__email-input');
      var hp = form.querySelector('[data-htv-hp]');
      var msg = form.querySelector('[data-htv-email-msg]');
      var sendBtn = form.querySelector('[data-htv-email-send]');
      var company = this.dataset.klaviyoCompany, listId = this.dataset.klaviyoList;
      var metric = this.dataset.klaviyoMetric || 'Requested Recipe Email';
      var revision = this.dataset.klaviyoRevision || '2024-10-15';
      function show(text, kind) { msg.textContent = text; msg.className = 'htv__email-msg is-' + kind; msg.removeAttribute('hidden'); }
      var email = (input.value || '').trim();
      if (hp && hp.value) { show(self._successText(), 'success'); input.value = ''; return; }
      if (!validEmail(email)) { show('Please enter a valid email address.', 'error'); return; }
      if (!company) { show(self._errorText(), 'error'); return; }
      sendBtn.disabled = true; var prev = sendBtn.textContent; sendBtn.textContent = '…';
      var headers = { 'Content-Type': 'application/json', revision: revision };
      var subBody = { data: { type: 'subscription', attributes: { profile: { data: { type: 'profile', attributes: { email: email } } }, custom_source: 'How-To Instructions Form' }, relationships: { list: { data: { type: 'list', id: listId } } } } };
      var evtBody = { data: { type: 'event', attributes: { profile: { data: { type: 'profile', attributes: { email: email } } }, metric: { data: { type: 'metric', attributes: { name: metric } } }, properties: { page_title: self.dataset.pageTitle || document.title, page_url: window.location.href, instructions_url: self.dataset.pdfUrl || '' } } } };
      var base = 'https://a.klaviyo.com/client/';
      var subReq = listId ? fetch(base + 'subscriptions/?company_id=' + encodeURIComponent(company), { method: 'POST', headers: headers, body: JSON.stringify(subBody) }) : Promise.resolve({ ok: true });
      var evtReq = fetch(base + 'events/?company_id=' + encodeURIComponent(company), { method: 'POST', headers: headers, body: JSON.stringify(evtBody) });
      Promise.all([subReq, evtReq]).then(function (res) {
        var ok = res.every(function (r) { return r.ok || r.status === 202; });
        if (ok) { show(self._successText(), 'success'); input.value = ''; }
        else { show(self._errorText(), 'error'); sendBtn.disabled = false; sendBtn.textContent = prev; }
      }).catch(function () { show(self._errorText(), 'error'); sendBtn.disabled = false; sendBtn.textContent = prev; });
    }
    _successText() { var f = this.querySelector('[data-htv-email-form]'); return (f && f.getAttribute('data-success')) || 'Sent! Check your inbox.'; }
    _errorText() { var f = this.querySelector('[data-htv-email-form]'); return (f && f.getAttribute('data-error')) || 'Something went wrong. Please try again.'; }

    /* ----- state machine ----- */
    setState(state, idx) {
      this.player.dataset.state = state;
      var v = (state === 'video');
      if (!v && this.video) this.video.pause();
      this.welcomeScreen.hidden = (state !== 'welcome');
      if (this.tipsScreen) this.tipsScreen.hidden = (state !== 'tips');
      if (this.ctaScreen) this.ctaScreen.hidden = (state !== 'cta');
      if (state === 'tips') { this.tipIndex = idx || 0; this.showTip(this.tipIndex); }
      if (state === 'cta' && this.ctaSecondary) this.ctaSecondary.textContent = this.ctaEnd ? this.replayLabel : this.keepLabel;
    }

    showTip(i) {
      this.tipSlides.forEach(function (el, n) { el.hidden = (n !== i); });
      var back = this.querySelector('[data-htv-tips-back]');
      if (back) back.hidden = false;
    }

    toVideo(time, autoplay) {
      this.setState('video');
      var v = this.video, self = this;
      if (!v) return;
      this.lastTime = isFinite(time) ? time : v.currentTime;
      var seek = function () {
        if (isFinite(time) && Math.abs(v.currentTime - time) > 0.3) {
          try { v.currentTime = time; } catch (e) { self._log('seek failed', e && e.message); }
        }
      };
      this._log('toVideo', 'time=' + time, 'autoplay=' + !!autoplay, 'readyState=' + v.readyState, 'net=' + v.networkState);
      if (autoplay) this.play();
      if (v.readyState >= 1) {
        seek();
      } else {
        var onMeta = function () { v.removeEventListener('loadedmetadata', onMeta); seek(); };
        v.addEventListener('loadedmetadata', onMeta);
      }
    }
    play() {
      if (!this.video) return;
      var self = this, v = this.video;
      this._log('play() called', 'readyState=' + v.readyState, 'paused=' + v.paused);
      var p = v.play();
      if (p && p.then) {
        p.then(function () { self._log('play() resolved'); }).catch(function (e) {
          self._log('play() rejected', e && e.name, e && e.message);
          var retry = function () {
            v.removeEventListener('seeked', retry);
            v.removeEventListener('canplay', retry);
            self._log('retrying play()');
            var q = v.play(); if (q && q.catch) q.catch(function (e2) { self._log('retry play() rejected', e2 && e2.name); });
          };
          v.addEventListener('seeked', retry);
          v.addEventListener('canplay', retry);
        });
      }
    }

    _log() {
      if (!this.debug || !window.console) return;
      try { console.log.apply(console, ['[how-to-video]'].concat(Array.prototype.slice.call(arguments))); } catch (e) {}
    }

    attachDebug() {
      if (!this.debug || !this.video) return;
      var self = this, v = this.video;
      ['loadedmetadata','loadeddata','canplay','canplaythrough','play','playing','pause','waiting','stalled','suspend','seeking','seeked','ended','error'].forEach(function (ev) {
        v.addEventListener(ev, function () {
          var err = v.error ? (' errorCode=' + v.error.code) : '';
          self._log('event:' + ev, 'rs=' + v.readyState, 'net=' + v.networkState, 'paused=' + v.paused, 'ct=' + (v.currentTime || 0).toFixed(2) + err);
        });
      });
      self._log('debug enabled', 'controls=' + v.hasAttribute('controls'), 'preload=' + v.preload, 'src=' + (v.currentSrc || '(pending)'));
    }
  }

  customElements.define('how-to-video', HowToVideo);
})();